import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withKeys as _withKeys, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "selector-search-header" }
const _hoisted_2 = ["aria-label"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.theModel !== undefined)
      ? (_openBlock(), _createBlock(_component_q_input, {
          key: 0,
          outlined: "",
          dense: "",
          ref: "header_search_input",
          color: "white",
          class: "selector-search-header__input",
          modelValue: _ctx.theModel,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.theModel) = $event)),
          "hide-bottom-space": "",
          placeholder: _ctx.showFreeInput ? _ctx.$t('search_or_new') : _ctx.$t('search_label'),
          debounce: "300",
          clearable: "",
          "clear-icon": _ctx.clearIconName,
          onClear: _cache[1] || (_cache[1] = ($event: any) => (_ctx.theModel = '')),
          onKeydown: [
            _withKeys(_withModifiers(_ctx.emitArrowDown, ["exact","prevent"]), ["down"]),
            _withKeys(_withModifiers(_ctx.emitArrowUp, ["exact","prevent"]), ["up"])
          ],
          onKeyup: _withKeys(_withModifiers(_ctx.emitEnter, ["stop","prevent"]), ["enter"])
        }, {
          append: _withCtx(() => [
            (_ctx.showFreeInput && _ctx.theModel !== undefined)
              ? (_openBlock(), _createBlock(_component_q_btn, {
                  key: 0,
                  onClick: _withModifiers(_ctx.emitFreeInput, ["stop","prevent"]),
                  dense: "",
                  flat: "",
                  color: "accent",
                  size: "md",
                  icon: "add",
                  class: "q-pa-none"
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true),
            _cache[3] || (_cache[3] = _createElementVNode("svg", {
              class: "selector-search-header__search-icon",
              width: "16",
              height: "16",
              viewBox: "0 0 16 16",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg"
            }, [
              _createElementVNode("path", {
                d: "M13.9998 13.9998L11.1064 11.1064",
                stroke: "#999999",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }),
              _createElementVNode("path", {
                d: "M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z",
                stroke: "#999999",
                "stroke-width": "1.5",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              })
            ], -1))
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder", "clear-icon", "onKeydown", "onKeyup"]))
      : _createCommentVNode("", true),
    (_ctx.showCloseButton)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "selector-search-header__close",
          "aria-label": _ctx.$t('close_selector'),
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.emitClose && _ctx.emitClose(...args)))
        }, _cache[4] || (_cache[4] = [
          _createElementVNode("svg", {
            width: "20",
            height: "20",
            viewBox: "0 0 20 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [
            _createElementVNode("path", {
              d: "M15 5L5 15",
              stroke: "#979797",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }),
            _createElementVNode("path", {
              d: "M5 5L15 15",
              stroke: "#979797",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            })
          ], -1)
        ]), 8, _hoisted_2))
      : _createCommentVNode("", true)
  ]))
}